import React, { useState } from 'react';
import { Card, Table, Input, Typography, Tag, Empty } from 'antd';
import { SearchOutlined, ShopOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { formatCurrency } from '../../utils/formatters';

const { Title, Text } = Typography;

const MOCK_COMMODITIES = [
  { id: 1, crop: 'Wheat (Gehu)', price: 2275, unit: 'quintal', market: 'Indore', change: 25, date: '2024-01-15' },
  { id: 2, crop: 'Cotton (Kapas)', price: 6500, unit: 'quintal', market: 'Rajkot', change: -100, date: '2024-01-15' },
  { id: 3, crop: 'Soybean', price: 4500, unit: 'quintal', market: 'Akola', change: 50, date: '2024-01-15' },
  { id: 4, crop: 'Groundnut', price: 5800, unit: 'quintal', market: 'Junagadh', change: -50, date: '2024-01-15' },
  { id: 5, crop: 'Rice (Chawal)', price: 2100, unit: 'quintal', market: 'Amravati', change: 0, date: '2024-01-15' },
  { id: 6, crop: 'Maize (Makka)', price: 1800, unit: 'quintal', market: 'Kota', change: 30, date: '2024-01-15' },
  { id: 7, crop: 'Turmeric (Haldi)', price: 15000, unit: 'quintal', market: 'Sangli', change: 500, date: '2024-01-15' },
  { id: 8, crop: 'Onion (Pyaz)', price: 1200, unit: 'quintal', market: 'Nashik', change: -200, date: '2024-01-15' },
];

export default function Market() {
  const { t } = useTranslation();
  const [search, setSearch] = useState('');

  const filtered = MOCK_COMMODITIES.filter((c) => c.crop.toLowerCase().includes(search.toLowerCase()));

  const columns = [
    { title: 'Commodity', dataIndex: 'crop', render: (v) => <Text strong>🌾 {v}</Text> },
    {
      title: 'Price', dataIndex: 'price',
      render: (v, r) => <span style={{ fontWeight: 600, fontSize: 16 }}>{formatCurrency(v)}<Text type="secondary" style={{ fontWeight: 400, fontSize: 12 }}>/{r.unit}</Text></span>,
    },
    {
      title: 'Change', dataIndex: 'change',
      render: (v) => (
        <Tag color={v > 0 ? 'green' : v < 0 ? 'red' : 'default'}>
          {v > 0 ? '+' : ''}{formatCurrency(v)}
        </Tag>
      ),
    },
    { title: 'Market', dataIndex: 'market', render: (v) => <Text type="secondary">{v}</Text> },
    { title: 'Date', dataIndex: 'date', render: (v) => <Text type="secondary">{v}</Text> },
  ];

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20, flexWrap: 'wrap', gap: 12 }}>
        <Title level={4} style={{ margin: 0, color: '#1a6b2a' }}><ShopOutlined /> {t('market')}</Title>
        <Input.Search placeholder="Search commodity..." value={search} onChange={(e) => setSearch(e.target.value)}
          prefix={<SearchOutlined />} style={{ width: 250 }} allowClear />
      </div>
      <Card style={{ borderRadius: 10 }}>
        <div style={{ marginBottom: 12 }}>
          <Text type="secondary">Mandi prices — updated daily. Connect to a market data API for live prices.</Text>
        </div>
        {filtered.length === 0 ? <Empty description="No commodities found" />
          : <Table dataSource={filtered} columns={columns} rowKey="id" pagination={{ pageSize: 20 }} />}
      </Card>
    </div>
  );
}
